(function () {
  'use strict';
  if (window.miProductoZoomLoaded) return;
  window.miProductoZoomLoaded = true;
  var viewers = new WeakMap();
  var galleryGesture = null;
  var suppressGalleryClick = 0;

  // A swipe/drag changes the carousel, never opens a photo on release.
  document.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    var trigger = event.target.closest('[data-mi-ampliar]');
    galleryGesture = trigger ? { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false } : null;
  }, true);
  document.addEventListener('pointermove', function (event) {
    if (!galleryGesture || galleryGesture.id !== event.pointerId) return;
    if (Math.hypot(event.clientX - galleryGesture.x, event.clientY - galleryGesture.y) > 8) galleryGesture.moved = true;
  }, true);
  function endGalleryGesture(event) {
    if (!galleryGesture || galleryGesture.id !== event.pointerId) return;
    if (galleryGesture.moved || event.type === 'pointercancel') suppressGalleryClick = Date.now() + 400;
    galleryGesture = null;
  }
  document.addEventListener('pointerup', endGalleryGesture, true);
  document.addEventListener('pointercancel', endGalleryGesture, true);

  function createViewer(dialog, root) {
    var viewport = dialog.querySelector('[data-mi-zoom-visor]');
    var image = dialog.querySelector('[data-mi-zoom-imagen]');
    var status = dialog.querySelector('[data-mi-zoom-estado]');
    var level = dialog.querySelector('[data-mi-zoom-nivel]');
    var minus = dialog.querySelector('[data-mi-zoom-menos]');
    var plus = dialog.querySelector('[data-mi-zoom-mas]');
    var pointers = new Map();
    var photos = [];
    var index = 0;
    var opener;
    var scale = 1, x = 0, y = 0, fitWidth = 0, fitHeight = 0;
    var gesture = null, swipe = null, moved = false, suppressTap = 0;
    var bodyOverflow, htmlOverflow;

    function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
    function draw() {
      var limitX = Math.max(0, (fitWidth * scale - viewport.clientWidth) / 2);
      var limitY = Math.max(0, (fitHeight * scale - viewport.clientHeight) / 2);
      x = clamp(x, -limitX, limitX);
      y = clamp(y, -limitY, limitY);
      image.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
      level.value = Math.round(scale * 100) + '%';
      minus.disabled = scale <= 1;
      plus.disabled = scale >= 4;
      viewport.style.cursor = scale > 1 ? (pointers.size ? 'grabbing' : 'grab') : 'zoom-in';
    }
    function fit() {
      if (!image.naturalWidth || !dialog.open) return;
      var ratio = Math.min(viewport.clientWidth / image.naturalWidth, viewport.clientHeight / image.naturalHeight);
      fitWidth = image.naturalWidth * ratio;
      fitHeight = image.naturalHeight * ratio;
      image.style.width = fitWidth + 'px';
      image.style.height = fitHeight + 'px';
      image.style.marginLeft = -fitWidth / 2 + 'px';
      image.style.marginTop = -fitHeight / 2 + 'px';
      draw();
    }
    function reset() { scale = 1; x = 0; y = 0; draw(); }
    function localPoint(clientX, clientY) {
      var rect = viewport.getBoundingClientRect();
      return { x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2 };
    }
    function zoom(next, point) {
      next = clamp(next, 1, 4);
      point = point || { x: 0, y: 0 };
      x = point.x - (point.x - x) * next / scale;
      y = point.y - (point.y - y) * next / scale;
      scale = next;
      draw();
    }
    function showPhoto(next) {
      index = (next + photos.length) % photos.length;
      pointers.clear();
      gesture = null;
      swipe = null;
      reset();
      image.style.visibility = 'hidden';
      status.textContent = 'Cargando imagen…';
      var source = photos[index].querySelector('img');
      image.alt = source.alt;
      image.src = photos[index].href;
      dialog.querySelector('[data-mi-zoom-contador]').textContent = 'Foto ' + (index + 1) + ' de ' + photos.length;
      dialog.querySelector('[data-mi-zoom-navegacion]').hidden = photos.length < 2;
      if (image.complete && image.naturalWidth) loaded();
    }
    function loaded() {
      fit();
      image.style.visibility = 'visible';
      status.textContent = '';
    }
    image.addEventListener('load', loaded);
    image.addEventListener('error', function () { status.textContent = 'No se pudo cargar la foto. Intenta con otra imagen.'; });
    dialog.querySelector('[data-mi-zoom-cerrar]').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('[data-mi-zoom-anterior]').addEventListener('click', function () { showPhoto(index - 1); });
    dialog.querySelector('[data-mi-zoom-siguiente]').addEventListener('click', function () { showPhoto(index + 1); });
    minus.addEventListener('click', function () { zoom(scale - .5); });
    plus.addEventListener('click', function () { zoom(scale + .5); });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = htmlOverflow;
      pointers.clear();
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === '+' || event.key === '=') { event.preventDefault(); zoom(scale + .5); }
      if (event.key === '-') { event.preventDefault(); zoom(scale - .5); }
      if (event.key === '0') { event.preventDefault(); reset(); }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        if (scale === 1) showPhoto(index + (event.key === 'ArrowRight' ? 1 : -1));
        else { x += event.key === 'ArrowRight' ? -60 : 60; draw(); }
      }
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault(); y += event.key === 'ArrowDown' ? -60 : 60; draw();
      }
    });
    viewport.addEventListener('wheel', function (event) {
      event.preventDefault();
      zoom(scale * Math.exp(-event.deltaY / 400), localPoint(event.clientX, event.clientY));
    }, { passive: false });
    function beginGesture() {
      var points = Array.from(pointers.values());
      if (points.length >= 2) {
        var a = points[0], b = points[1];
        gesture = { point: localPoint((a.x + b.x) / 2, (a.y + b.y) / 2), distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), scale: scale, x: x, y: y };
        moved = true;
      } else if (points.length === 1) {
        gesture = { point: points[0], scale: scale, x: x, y: y };
      } else gesture = null;
    }
    viewport.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      viewport.setPointerCapture(event.pointerId);
      if (pointers.size === 1) {
        moved = false;
        swipe = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY, time: Date.now() } : null;
      } else swipe = null; // A pinch never changes photos when either finger lifts.
      beginGesture();
      draw();
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId) || !gesture) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      var points = Array.from(pointers.values());
      if (points.length >= 2) {
        var a = points[0], b = points[1];
        var center = localPoint((a.x + b.x) / 2, (a.y + b.y) / 2);
        scale = clamp(gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance, 1, 4);
        x = center.x - (gesture.point.x - gesture.x) * scale / gesture.scale;
        y = center.y - (gesture.point.y - gesture.y) * scale / gesture.scale;
      } else {
        var dx = event.clientX - gesture.point.x, dy = event.clientY - gesture.point.y;
        if (Math.hypot(dx, dy) > 6) moved = true;
        if (scale > 1) { x = gesture.x + dx; y = gesture.y + dy; }
      }
      draw();
    });
    function endPointer(event) {
      if (!pointers.has(event.pointerId)) return;
      var dx = swipe ? event.clientX - swipe.x : 0;
      var dy = swipe ? event.clientY - swipe.y : 0;
      // Fast one-finger horizontal swipes navigate, even when zoomed.
      // Slow/diagonal drags still pan the enlarged photo.
      var changePhoto = event.type === 'pointerup' && swipe && photos.length > 1 &&
        Date.now() - swipe.time < 700 && Math.abs(dx) > Math.max(48, viewport.clientWidth * .15) &&
        Math.abs(dx) > Math.abs(dy) * 1.5;
      if (moved || event.type === 'pointercancel') suppressTap = Date.now() + 400;
      pointers.delete(event.pointerId);
      if (changePhoto) {
        suppressTap = Date.now() + 400;
        showPhoto(index + (dx < 0 ? 1 : -1));
        return;
      }
      swipe = null;
      beginGesture();
      draw();
    }
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);
    viewport.addEventListener('click', function (event) {
      if (Date.now() < suppressTap) return;
      zoom(scale > 1 ? 1 : 2, localPoint(event.clientX, event.clientY));
    });
    if (window.ResizeObserver) new ResizeObserver(fit).observe(viewport);
    else window.addEventListener('resize', fit);
    return function (trigger) {
      photos = Array.from(root.querySelectorAll('[data-mi-ampliar]'));
      opener = trigger;
      bodyOverflow = document.body.style.overflow;
      htmlOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      showPhoto(photos.indexOf(trigger));
    };
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mi-ampliar]');
    if (!trigger || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (Date.now() < suppressGalleryClick) { event.preventDefault(); return; }
    var root = trigger.closest('.mi-prod');
    var dialog = root && root.querySelector('[data-mi-zoom]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (!viewers.has(dialog)) viewers.set(dialog, createViewer(dialog, root));
    viewers.get(dialog)(trigger);
  });
})();
